import config from '../config';
import * as actions from '../actions/vendors';
import fetch from 'cross-fetch';
import store from 'store2';
import { addNotification as notify } from 'reapop';
import { push } from 'react-router-redux';
import { path } from "ramda";

export function getVendorsList() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetchUrl(`vendor`)
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(actions.getVendorsList({ list: json }));
          }
        })
        .catch(response => {
          dispatch(actions.getVendorsList({ list: [] }));
          dispatch(notify({
            title: 'Get Vendors List',
            message: 'Failed to get vendors list',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
};

export function getVendor(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetchUrl(`vendor/${id}`)
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(actions.getVendor({ currentVendor: json }));
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Get Vendor',
            message: 'Failed to get vendor',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
};

export function addVendor(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetchUrl(`vendor`, 'POST', data)
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json.detail && !json.added) {
            dispatch(notify({
              title: 'Add New Vendor',
              message: JSON.stringify(json.detail),
              status: 'error',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          } else if (json) {
            dispatch(push('/pages/vendors'));
            dispatch(notify({
              title: 'Add New Vendor',
              message: 'Vendor added successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Add New Vendor',
            message: 'Failed to add vendor',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
};

export function updateVendor(id, data, remove) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetchUrl(`vendor/${id}`, 'PUT', data)
        .then((response) => {
          return response.json();
        })
        .then(json => {
          const error = path(['detail'], json);
          if (error) {
            dispatch(notify({
              title: 'Update Vendor',
              message: JSON.stringify(error),
              status: 'error',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
          else {
            if (remove && remove.length) {
              Promise.all(remove.map((id) => fetchUrl(`vendor/deleteContact/${id}`, 'DELETE')))
                .then((results) => Promise.all(results.map(result => result.json())))
                .then((arr) => arr.forEach(item => {
                  if (item.code !== 200) throw Error();
                }))
                .catch(() => dispatch(notify({
                  title: 'Delete Vendor Contact',
                  message: 'Failed to delete vendor contact',
                  status: 'error',
                  position: 'tr',
                  dismissible: true,
                  dismissAfter: 3000
                })));
            }
            dispatch(notify({
              title: 'Update Vendor',
              message: 'Vendor has been updated successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
          setTimeout(function () {
            window.location.reload();
          }, 1000);
        })
        .catch(response => {
          dispatch(notify({
            title: 'Update Vendor',
            message: 'Failed to update vendor',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
};

export function deleteVendor(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetchUrl(`vendor/${data.id}`, 'DELETE')
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(actions.deleteVendor({ id: data.id }));
            dispatch(notify({
              title: 'Delete Vendor',
              message: 'Vendor deleted successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
    }
  }
};

const fetchUrl = (url, method = 'GET', data) => {
  return fetch(`${config.apiEndpoint}/${url}`, {
    method,
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `bearer ${store.get('user').api_token}`
    },
    credentials: 'same-origin'
  })
};



// WEBPACK FOOTER //
// ./src/api/vendors.js